import userActionsWatchedRequest from './userActionsWatched.request';
import createService from '../Utils/createService';
import handleServiceError from '../Utils/handleServiceError';
import { ServiceTypes } from '../Constants/api.constants';
import {
    RETRY_COUNT_API_SERVICE_DEFAULT,
} from '../../Errors/Constants/Error.retries';

const createUserActionsWatchedService = (configStoreUpdate$, handleError) =>
    createService(
        ServiceTypes.USER_ACTIONS_WATCHED,
        configStoreUpdate$,
        userActionsWatchedRequest,
        handleServiceError(ServiceTypes.USER_ACTIONS_WATCHED, handleError),
        RETRY_COUNT_API_SERVICE_DEFAULT,
    );

export default createUserActionsWatchedService;
